import React from "react";
import { Box, Text, Separator } from "@twilio-paste/core";
import {
  Modal,
  ModalHeader,
  ModalHeading,
  ModalBody,
} from "@twilio-paste/core/modal";
import { Button } from "@twilio-paste/button";
import { CloseIcon } from "@twilio-paste/icons/esm/CloseIcon";
import { ConversationCustomerDto } from "../../dto/conversation";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  customers: ConversationCustomerDto[];
};

const fullName = (c: ConversationCustomerDto) =>
  `${c.name ?? ""} ${c.surname ?? ""}`.trim();

export const CustomerMatchesModal: React.FC<Props> = ({
  isOpen,
  onClose,
  customers,
}) => {
  return (
    <Modal
      ariaLabelledby="customer-matches-modal"
      isOpen={isOpen}
      onDismiss={onClose}
      size="default"
    >
      <ModalHeader>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <ModalHeading as="h3" id="customer-matches-modal">
            Contatti CRM
          </ModalHeading>
        </Box>
      </ModalHeader>

      <ModalBody>
        <Box
          borderWidth="borderWidth10"
          borderStyle="solid"
          borderColor="colorBorderWeak"
          borderRadius="borderRadius20"
          overflow="hidden"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            padding="space40"
            backgroundColor="colorBackgroundPrimaryWeakest"
          >
            <Text as="div" fontWeight="fontWeightSemibold">
              Customer Code
            </Text>
            <Text as="div" fontWeight="fontWeightSemibold">
              FullName
            </Text>
          </Box>

          <Separator orientation="horizontal" />

          {/* Rows */}
          <Box>
            {customers.map((c, idx) => (
              <React.Fragment key={`${c.code}-${c.name}-${c.surname}-${idx}`}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  padding="space40"
                  columnGap="space60"
                >
                  <Text as="div" color="colorTextWeak">
                    {c.code}
                  </Text>
                  <Text as="div">{fullName(c)}</Text>
                </Box>
                {idx < customers.length - 1 ? (
                  <Separator orientation="horizontal" />
                ) : null}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </ModalBody>
    </Modal>
  );
};
